import { useMemo } from 'react';
import { ComponentInstance } from '@ayumia/component-runtime';
import { useAppServices } from '../views/ViewContext';
import { needsRunSandbox } from './run-sandbox';

/**
 * Instance d'un composite publié (kind `component`) cité par une vue : onglet de détail, carte d'une
 * collection (ADR-048, ADR-099). Le manifeste vient de la résolution de la vue ; `$record` est
 * l'enregistrement affiché, `$inputs` les entrées déclarées par l'emplacement. Le bac à sable n'est
 * demandé que si le composant (ou l'un de ceux qu'il cite) contient `run` (ADR-083 §4).
 */
export function useDeclaredComponent(artifactId: string, record: unknown, inputs?: Readonly<Record<string, unknown>>): ComponentInstance | null {
  const services = useAppServices();
  const manifest = services.components.get(artifactId);
  return useMemo(() => {
    if (manifest === undefined) return null;
    const resolveComponent = (id: string) => services.components.get(id);
    const run = services.runSandbox !== undefined && needsRunSandbox(manifest, resolveComponent) ? { runSandbox: services.runSandbox(), runEnabled: services.componentRun?.get(artifactId) !== false } : {};
    return new ComponentInstance(manifest, { record, context: services.context, theme: services.theme, gateway: services.gateway, resolveComponent, ...(inputs === undefined ? {} : { inputs: { ...inputs } }), ...run });
  }, [artifactId, manifest, record, inputs, services]);
}
